<template>
  <div class="search-item">
    <span class="span">区域</span>
    <el-select v-if="type == 'area' || type == 'town' || type == 'village'" @change="changeArea" size="mini" style="width:140px" clearable :value="area" placeholder="请选择区">
      <el-option
        v-for="item in baseOptions"
        :key="item.id"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select>
    <el-select v-if="type == 'town' || type == 'village'" @change="changeTown" style="margin-left:10px;width:140px;" size="mini" clearable :value="town" placeholder="请选择乡镇/街道">
      <el-option
        v-for="item in townOptions"
        :key="item.id"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select>
    <!-- <el-select v-if="type == 'village'" @change="changeVillage" style="margin-left:10px;width:140px;margin-right:15px" size="mini" clearable :value="village" placeholder="请选择村/社区">
      <el-option
        v-for="item in villageOptions"
        :key="item.id"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select> -->
  </div>
</template>

<script>
import {api} from '@/api/api'
import store from '@/vuex/store'
export default {
  props: {
    type: {
      type: String,
      default: 'village'
    },
    area: [Number, String],
    town: [Number, String],
    town_name: [Number, String],
    village: [Number, String]
  },
  data () {
    return {
      townOptions: [],
      villageOptions: [],
    }
  },
  computed: {
    baseOptions () {
      let cityArr = JSON.parse(localStorage.getItem('baseArea'))
      for (let item of cityArr) {
        if (item.id == store.state.cityId) {
          return [...item.children]
        }
      }
    },
  },
  watch: {
    area: {
      immediate: true,
      handler: function (val) {
        for (let item of this.baseOptions) {
          if (val === item.id) {
            this.townOptions = item.children
            break
          }
        }
      }
    },
    town: {
      immediate: true,
      handler: function (val) {
        this.$http.post(api[`getVillageByTown`], {town_id: val}).then(res => {
          if (res.data.code === 0) {
            this.villageOptions = res.data.data
          } else {
            console.log(res.data.msg)
          }
        })
      }
    }
  },
  created () {
  },
  mounted () {
    this.$nextTick(() => {
      const code = this.getAreaCodeByHost();
      if (code) {
        // ② 立即回显（父组件 v-model 会同步）
        this.$emit('update:area', code);
        // ③ 触发联动：生成乡镇列表
        this.changeArea(code);
      }
    })
  },
  methods: {
    getAreaCodeByHost() {
      if (this.$store.getters.hostCL) return 350112; // 长乐
      return ''; // 匹配不到就留空
    },
    changeArea (id) {
      this.townOptions = []
      if (id) {
        for (let item of this.baseOptions) {
          if (id === item.id) {
            this.townOptions = item.children
            break
          }
        }
        this.$emit('update:area', id)
        this.$emit('update:town', '')
        this.$emit('update:village', '')
      } else {
        this.$emit('update:area', '')
        this.$emit('update:town', '')
        this.$emit('update:village', '')
      }
    },
    changeTown (id) {
      if (id) {
        this.$emit('update:town', id)
        this.$emit('update:village', '')
        this.villageOptions = []
        this.$http.post(api[`getVillageByTown`], {town_id: id}).then(res => {
          if (res.data.code === 0) {
            this.villageOptions = res.data.data
          } else {
            console.log(res.data.msg)
          }
        })
      } else {
        this.$emit('update:town', '')
        this.$emit('update:village', '')
      }
    },
    changeVillage (id) {
      if (id) {
        this.$emit('update:village', id)
      } else {
        this.$emit('update:village', '')
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/selectArea/selectArea.vue